import { IRoomsCountsByHouse } from '../../types/newbuilding/layouts';
import { IApplicationState } from '../../types/redux';

export function getLayoutsHouses(state: IApplicationState): IRoomsCountsByHouse[] {
  return state.newbuilding.layoutsInfo?.roomsCountsByHouse || [];
}

export function getLayoutsInfoText(state: IApplicationState): string {
  return state.newbuilding.layoutsInfo?.countText || '';
}

export function getHasTour(state: IApplicationState): boolean {
  return state.newbuilding.layoutsInfo?.hasTour || false;
}
